(function () {
  /* eslint-disable no-useless-escape */
  // Grid.js (window.gridjs) is loaded by sections/data-table.liquid
  class DataTable extends HTMLElement {
    constructor() {
      super();
      this.sectionid = this.dataset.sectionid;
    }
    connectedCallback() {
      this.listenForChanges();
    }
    listenForChanges() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
            this.renderData();
          }
        });
      });
      const observeElements = this.querySelectorAll('._data_data');
      observeElements.forEach((el) => {
        observer.observe(el, {
          attributes: true,
          attributeFilter: ['data-value'],
        });
      });
    }
    tryRepairAndParseJSON(malformedJSON) {
      const repairedJSON1 = malformedJSON.replace(/""/g, '"');
      return JSON.parse(repairedJSON1);
    }
    renderData() {
      const titles = this.tryRepairAndParseJSON(
        document.querySelector('._data_titles').dataset.value
      );
      const data = this.tryRepairAndParseJSON(document.querySelector('._data_data').dataset.value);
      // Attempt to fetch avgData
      const avgElement = document.querySelector('._data_data_avg');
      let avgData = null;
      if (avgElement && avgElement.dataset.value) {
        avgData = this.tryRepairAndParseJSON(avgElement.dataset.value);
      }
      // Check if avgData exists and construct mergedData accordingly
      const mergedData = avgData
        ? titles.map((e, i) => [e, data[i], avgData[i]])
        : titles.map((e, i) => [e, data[i]]);
      // Clear the container before rendering
      while (this.firstChild) {
        this.firstChild.remove();
      }
      const gridColumns = avgData ? ['Name', 'Score', 'Average Score'] : ['Name', 'Score'];
      const grid = new gridjs.Grid({
        columns: gridColumns,
        data: mergedData,
        search: true,
        sort: true,
      });
      grid.render(this);
    }
  }
  customElements.define('data-table', DataTable);
})();
